// Build information, automatically generated by `ng-info`
const build = {
    version: "2.02.00",
    timestamp: "Thu May 28 2026 10:37:22 GMT-0500 (Central Daylight Time)",
    message: null,
    git: {
        user: "Robert-Schoen-Alight",
        branch: "r2.02.00",
        hash: "9f2795",
        fullHash: "9f279575a7e52c029ab686942e436a31e21f5ef5"
    }
};

export default build;